import { Controller } from "@hotwired/stimulus";

// A full-screen search/filter panel. The panel can start hidden either with the
// `hidden` attribute or with an inline `display: none`; both are kept in sync.
//
// An optional brand color value (data-overlay-brand-color-value) is exposed to
// CSS as --brand-primary-color, e.g. for the selected state of filter pills.
export default class extends Controller {
  static targets = ["panel", "clearButton"];
  static values = { brandColor: String };

  connect() {
    if (this.brandColorValue) {
      this.element.style.setProperty("--brand-primary-color", this.brandColorValue);
    }
  }

  open(event) {
    event.preventDefault();
    this.updateClearButton();
    this.panelTarget.hidden = false;
    this.panelTarget.style.display = "block";
  }

  close(event) {
    event.preventDefault();
    this.hidePanel();
  }

  clearForm(event) {
    event.preventDefault();
    this.panelTarget.querySelectorAll("input[type=text], select").forEach(el => {
      const $el = window.jQuery && window.jQuery(el);
      if ($el && $el.hasClass("hasDatepicker")) {
        $el.datepicker("setDate", null);
        // setDate fires no event; announce the change so listeners can react,
        // e.g. date_range_controller.js lifting the other end's limit.
        el.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        el.value = "";
        if ($el && $el.hasClass("select2")) $el.trigger("change");
      }
    });
    this.panelTarget.querySelectorAll("input[type=checkbox]").forEach(el => {
      el.checked = false;
    });
    this.clearButtonTarget.style.visibility = "hidden";
  }

  updateClearButton() {
    const hasValues = Array.from(
      this.panelTarget.querySelectorAll("input[type=text], select")
    ).some(el => el.value !== "") ||
      this.panelTarget.querySelector("input[type=checkbox]:checked") !== null;
    this.clearButtonTarget.style.visibility = hasValues ? "visible" : "hidden";
  }

  handleKeydown(event) {
    if (!this.isOpen) return;
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      this.panelTarget.querySelector("form").requestSubmit();
    }
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  get isOpen() {
    return !this.panelTarget.hidden && this.panelTarget.style.display !== "none";
  }

  hidePanel() {
    this.panelTarget.hidden = true;
    this.panelTarget.style.display = "none";
  }
}
